.build-form-fields.appcues-style

.controls.clearfix
    a.appcues-style.btn.btn-link.btn-sm.control-link(data-action='delete'): i.fa.fa-trash
    a.appcues-style.btn.btn-primary.btn-sm.pull-right(data-action='saveAndClose') Save
    a.appcues-style.btn.btn-default.btn-sm.pull-right(data-action='close') Cancel
